import { render, staticRenderFns } from "./GiftcardTopUp.vue?vue&type=template&id=05aaf1f8"
import script from "./GiftcardTopUp.vue?vue&type=script&lang=js"
export * from "./GiftcardTopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports